import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { TERMS_AND_CONDITIONS, TERMS_EFFECTIVE_DATE } from '../constants/terms';

interface TermsModalProps {
  show: boolean;
  onHide: () => void;
  /** Optional: shown as a primary action when set (e.g. "Agree & Continue"). */
  onAccept?: () => void;
}

/**
 * Scrollable modal that renders the full ProvisionMart Terms & Conditions.
 * Used by every authentication / signup screen via <TermsCheckbox />.
 */
const TermsModal: React.FC<TermsModalProps> = ({ show, onHide, onAccept }) => (
  <Modal show={show} onHide={onHide} size="lg" scrollable centered>
    <Modal.Header closeButton>
      <Modal.Title>
        <div style={{ fontWeight: 700 }}>Terms &amp; Conditions</div>
        <div style={{ fontSize: 12, color: '#6B7280', fontWeight: 500 }}>
          Effective {TERMS_EFFECTIVE_DATE}
        </div>
      </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <pre
        style={{
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
          fontFamily: 'inherit',
          fontSize: 13,
          lineHeight: 1.55,
          color: '#1F2937',
          margin: 0,
        }}
      >
        {TERMS_AND_CONDITIONS}
      </pre>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="outline-secondary" onClick={onHide}>
        Close
      </Button>
      {onAccept && (
        <Button
          variant="success"
          onClick={() => {
            onAccept();
            onHide();
          }}
        >
          I Agree
        </Button>
      )}
    </Modal.Footer>
  </Modal>
);

export default TermsModal;

